import Layout from '@/layouts/Layout';
import { useChatStream } from '@/hooks/useChatStream';
import { ChatInterface } from '@/components/chat/ChatInterface';
import { router } from '@inertiajs/react';

export default function New() {
  const {
    input,
    setInput,
    msgList,
    loading,
    error,
    streamingMsg,
    bottomRef,
    inputRef,
    copiedId,
    handleCopy,
    handleSend,
    image,
    setImage,
  } = useChatStream({
    streamUrl: `/patients/chats/create_stream`,
    initialMessages: [],
    onStreamComplete: (chatId?: number) => {
      if (chatId) {
        // Naviga alla show della chat senza ricarico completo
        router.visit(`/patients/chats/${chatId}`, { preserveState: true, replace: true });
      }
    },
  });

  return (
    <Layout user={{ name: 'Cliente' }}>
      <ChatInterface
        title={`Nuova Chat`}
        input={input}
        setInput={setInput}
        msgList={msgList}
        loading={loading}
        error={error}
        streamingMsg={streamingMsg}
        bottomRef={bottomRef}
        inputRef={inputRef}
        copiedId={copiedId}
        handleCopy={handleCopy}
        handleSend={handleSend}
        image={image}
        setImage={setImage}
      />
    </Layout>
  );
}
